export enum CurrencyCodes {
    EUR = "EUR",
    USD =  "USD"
}